/**
 * Identifiants internes des POI et des documents — EF-POI-015, EF-RBK-005.
 *
 * Un identifiant est attribué à la création et ne change jamais, ni lors d'un
 * recalcul, ni lors d'un export, ni lors d'une importation.
 */

/** Repli déterministe lorsque `crypto.randomUUID` est indisponible. */
let counter = 0;

export function newId(): string {
  const globalCrypto = globalThis.crypto as Crypto | undefined;
  if (globalCrypto !== undefined && typeof globalCrypto.randomUUID === 'function') {
    return globalCrypto.randomUUID();
  }
  counter += 1;
  const random = Math.random().toString(16).slice(2, 14).padEnd(12, '0');
  return `${Date.now().toString(16)}-${counter.toString(16).padStart(4, '0')}-${random}`;
}
